import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import './Escribania.css';

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = {
            success: false,
        };
  }

  volver = () => {
    this.setState({
      success: true,
    });
  }

  render() {
    if(this.state.success){
      return <Redirect to="/escribania"/>
    }else{
      return (
        <Container className={'econt-success'}>
          <Row className={'mt-5'}>

            <Col className="col-12 col-md-6 text-center ">
              <div className='eImgExito'></div>
            </Col>

            <Col className="col-12 col-md-6 my-auto">
              <h3 className={'eMsgSuccess'}>El formulario ha sido enviado exitosamente.</h3>
            </Col>

          </Row>
          <Row className={'mt-3'}>
            <Col className="col-12 col-md-12 my-auto">
              {/* <Button color={'success'} size="lg" className={'eBtnForm'} onClick={() => window.open('http://www.grupobartolome.com//',"_self")}>Volver</Button> */}
              <Button color={'success'} size="lg" className={'eBtnForm'} onClick={() => {this.volver()}}>Volver</Button>
            </Col>
          </Row>
        </Container>
      );
    }
  }
}

export default Success;



// WEBPACK FOOTER //
// ./src/views/Escribania/Success.js